export const AuthLabels = {
  Email: "Email",
  Password: "Password",
  Login: "Login",
  ForgotPassword: "Forgot Password",
  ChangePassword: "Change Password",
  OldPassword: "Old Password",
  NewPassword: "New Password",
  ConfirmPassword: "Confirm Password",
  SendOTP: "Send OTP",
  OTP: "OTP",
  VerifyOTP: "Verify OTP",
  ResendOTP: "Resend OTP",
  
}